export interface ICheekSwabRequest {
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    contactPhone: string,
    email: string,
    dob: string
}